import { render } from "./FormSubscription.vue?vue&type=template&id=19b92d55"
import script from "./FormSubscription.vue?vue&type=script&lang=js"
export * from "./FormSubscription.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__